import React from 'react';
import SetpointProfilesTable from './setpoint-limit-profiles-table';
import { useIsSmallScreen } from '../../system/SystemMediaQueriesProvider';

export function SetpointLimitProfilesMain() {
  const isSmall = useIsSmallScreen();

  return (
    <div
      style={{
        margin: isSmall ? '0px' : '10px 4px',
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        alignItems: 'stretch',
      }}
    >
      <SetpointProfilesTable />
    </div>
  );
}
